module.exports = __webpack_public_path__ + "img/loading.9f7adc8c.gif";